import script from "./EditCompanyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCompanyForm.vue?vue&type=script&setup=true&lang=js"

import "./EditCompanyForm.vue?vue&type=style&index=0&id=cf692d92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf692d92"]])

export default __exports__